import NextLink from '@allesauto/core/nextLink';
import TextLink from '@allesauto/core/textLink';
import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import MastercardIcon from '@allesauto/design/graphics/Mastercard-Logo.svg';
import PayPalIcon from '@allesauto/design/graphics/PayPal-Logo.svg';
import SofortIcon from '@allesauto/design/graphics/Sofortueberwesiung-Logo.svg';
import VisaIcon from '@allesauto/design/graphics/Visa-Logo.svg';
import { CashOption, PaymentType, SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { isAuregoShop, isWhiteLabel } from '@allesauto/utils/funcs.ts';
import clsx from 'clsx';
import * as React from 'react';
import { useIntl } from 'react-intl';

import FooterPrice from '../../OverlayFormFooter/OverlayFooterPrice';
import Footer from '../../OverlayFormFooter/OverlayFormFooter';

export interface CashProps {
  price: number;
  options?: SchemaTypes.CashOption[];
  onSubmit?: (price: number) => void;
}

const Cash = ({ price, options, onSubmit }: CashProps) => {
  const intl = useIntl();
  const whiteLabel = useWhiteLabel();

  const className = {
    topTextBlock: 'mb-40px md:mb-60px',
    topText: 'mb-20px md:mb-15px',
    option:
      'aurego-border-bottom border-grey30 border-b-1px flex justify-between py-10px md:py-15px',
    icon: 'h-[20px]',
  };

  return (
    <>
      <div className={className.topTextBlock}>
        <p className={className.topText}>
          {isWhiteLabel(whiteLabel)
            ? translate(intl, 'ui.PAYMENT_OPTIONS.CASH.TEXT_WL')
            : translate(intl, 'ui.PAYMENT_OPTIONS.CASH.TEXT')}
        </p>
        {!whiteLabel && (
          <NextLink href="/pages/autokauf-bezahlung" passHref legacyBehavior>
            <TextLink text={translate(intl, 'ui.PAYMENT_OPTIONS.CASH.LINK')} />
          </NextLink>
        )}
      </div>

      <div>
        {(options ?? []).map((opt, i) => (
          <div
            key={opt}
            className={clsx(
              className.option,
              i === 0
                ? `${
                    isAuregoShop(whiteLabel)
                      ? 'aurego-border-top'
                      : 'border-t-1px'
                  }`
                : null
            )}
          >
            <div>
              {translate(intl, `ui.PAYMENT_OPTIONS.CASH.OPTIONS.${opt}`)}
            </div>
            <div className="flex">
              {opt === CashOption.BankTransfer && (
                <SofortIcon className={className.icon} />
              )}
              {opt === CashOption.CreditCard && (
                <>
                  <VisaIcon className={clsx(className.icon, 'mr-20px')} />
                  <MastercardIcon className={className.icon} />
                </>
              )}
              {opt === CashOption.Paypal && (
                <PayPalIcon className={className.icon} />
              )}
            </div>
          </div>
        ))}
      </div>

      <Footer
        buttonText={translate(intl, 'ui.PAYMENT_OPTIONS.BUTTON_TEXT')}
        onButtonClick={() => onSubmit && onSubmit(price)}
        buttonTestId="button--accept"
      >
        <FooterPrice paymentType={PaymentType.CashRange} amount={price} />
      </Footer>
    </>
  );
};

export default Cash;
